import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import * as Icons from "lucide-react";
import { DATE_PRESETS, rangeFor } from "@/lib/dateRange";

// value = { preset, from, to, field }; fields = [{ key, label }] for which date to filter on.
export function DateRangeFilter({ value, onChange, fields, testId = "date-filter" }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      <Icons.CalendarRange className="h-4 w-4 text-muted-foreground" />
      {fields && fields.length > 1 && (
        <Select value={value.field} onValueChange={(f) => set({ field: f })}>
          <SelectTrigger className="h-9 w-40 text-xs" data-testid={`${testId}-field`}><SelectValue /></SelectTrigger>
          <SelectContent>{fields.map((f) => <SelectItem key={f.key} value={f.key} className="text-xs">{f.label}</SelectItem>)}</SelectContent>
        </Select>
      )}
      <Select value={value.preset} onValueChange={(p) => set({ preset: p })}>
        <SelectTrigger className="h-9 w-36 text-xs" data-testid={`${testId}-preset`}><SelectValue /></SelectTrigger>
        <SelectContent>{DATE_PRESETS.map((p) => <SelectItem key={p.key} value={p.key} className="text-xs" data-testid={`${testId}-opt-${p.key}`}>{p.label}</SelectItem>)}</SelectContent>
      </Select>
      {value.preset === "custom" && (
        <>
          <Input type="date" value={value.from || ""} onChange={(e) => set({ from: e.target.value })} className="h-9 w-36 text-xs" data-testid={`${testId}-from`} />
          <span className="text-xs text-muted-foreground">to</span>
          <Input type="date" value={value.to || ""} onChange={(e) => set({ to: e.target.value })} className="h-9 w-36 text-xs" data-testid={`${testId}-to`} />
        </>
      )}
    </div>
  );
}

export const useRange = (v) => rangeFor(v.preset, v.from, v.to);
export const initialRange = (field = "created_at") => ({ preset: "all", from: "", to: "", field });
